import { createSelector } from "@ngrx/store";
import * as fromLayout from '@app/core/reducers/layout.reducer';
import { getLayoutState } from ".";

export const getPortal = createSelector(getLayoutState, fromLayout.getPortal);

export const getLogo = createSelector(getLayoutState, fromLayout.getLogo);
export const getTitle = createSelector(getLayoutState, fromLayout.getTitle);
